"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _loadGrouped = require("../actions/campaignCreator/findPersonas/loadGrouped");

var _GroupedTab = _interopRequireDefault(require("../components/GroupedTab"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    isFetching: state.findPersonasGrouped.isFetching,
    groupedPersonaRecords: state.findPersonasGrouped.records,
    selectedCharacteristics: state.selectedCharacteristics,
    selectedPersonas: state.findPersonasSelected.records,
    filters: state.profilingFilters,
    theme: state.themeFilter.value
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadGrouped: _loadGrouped.loadGrouped
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GroupedTab["default"]);

exports["default"] = _default;